import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@mui/material";
// https://codepen.io/Misty1636/pen/ZdzZPe
export const MeteorShower = () => {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
.star {
 width: 1px;
 height: 1px;
 background: transparent;
 box-shadow: , 1396px 94px #fff, 772px 452px #fff, 1279px 424px #fff, 1650px 98px #fff, 1752px 616px #fff, 316px 513px #fff, 860px 886px #fff, 1303px 788px #fff, 1772px 536px #fff, 1597px 788px #fff, 1079px 949px #fff, 1106px 413px #fff, 511px 207px #fff, 893px 537px #fff, 250px 215px #fff, 530px 465px #fff, 1044px 243px #fff, 1369px 391px #fff, 71px 923px #fff, 498px 158px #fff, 373px 496px #fff, 151px 138px #fff, 1255px 814px #fff, 1670px 141px #fff, 1824px 123px #fff, 195px 720px #fff, 408px 890px #fff, 1165px 480px #fff, 718px 685px #fff, 891px 543px #fff, 1858px 922px #fff, 1269px 628px #fff, 118px 464px #fff, 162px 512px #fff, 522px 905px #fff, 370px 929px #fff, 20px 175px #fff, 401px 444px #fff, 1628px 753px #fff, 513px 81px #fff, 976px 930px #fff, 1462px 545px #fff, 932px 538px #fff, 589px 585px #fff, 794px 75px #fff, 1472px 241px #fff, 1632px 939px #fff, 1766px 230px #fff, 1885px 827px #fff, 84px 260px #fff, 1788px 432px #fff, 905px 545px #fff, 442px 291px #fff, 1224px 216px #fff, 1599px 864px #fff, 1485px 535px #fff, 671px 261px #fff, 98px 224px #fff, 1176px 305px #fff, 361px 121px #fff, 1467px 517px #fff, 723px 386px #fff, 1865px 101px #fff, 291px 220px #fff, 269px 861px #fff, 518px 559px #fff, 417px 772px #fff, 1039px 346px #fff, 450px 117px #fff, 655px 171px #fff, 503px 662px #fff, 1045px 245px #fff, 10px 85px #fff, 918px 997px #fff, 1310px 836px #fff, 629px 782px #fff, 904px 870px #fff, 923px 813px #fff, 1822px 102px #fff, 1214px 91px #fff, 598px 907px #fff, 26px 226px #fff, 1269px 605px #fff, 522px 21px #fff, 184px 413px #fff, 452px 951px #fff, 452px 983px #fff, 625px 892px #fff, 1293px 630px #fff, 1231px 352px #fff, 1276px 825px #fff, 229px 458px #fff, 535px 932px #fff, 445px 160px #fff, 1716px 956px #fff, 1124px 321px #fff, 315px 645px #fff, 196px 560px #fff, 1150px 313px #fff, 810px 689px #fff, 1229px 370px #fff, 1279px 977px #fff, 1178px 864px #fff, 405px 552px #fff, 888px 929px #fff, 524px 305px #fff, 1371px 90px #fff, 679px 969px #fff, 1781px 634px #fff, 1475px 514px #fff, 1879px 254px #fff, 761px 838px #fff, 50px 549px #fff, 1856px 452px #fff, 1754px 661px #fff, 230px 896px #fff, 1444px 18px #fff, 1198px 301px #fff, 1712px 793px #fff, 1509px 358px #fff, 1362px 207px #fff, 33px 466px #fff, 675px 721px #fff, 1495px 895px #fff, 141px 440px #fff, 542px 746px #fff, 307px 661px #fff, 253px 252px #fff, 1211px 882px #fff, 1374px 318px #fff, 364px 144px #fff, 1167px 607px #fff, 364px 369px #fff, 1567px 586px #fff, 831px 414px #fff, 1472px 33px #fff, 637px 810px #fff, 1365px 755px #fff, 1243px 641px #fff, 268px 844px #fff, 1492px 581px #fff, 274px 406px #fff, 196px 925px #fff, 975px 83px #fff, 1889px 232px #fff, 1573px 282px #fff, 95px 540px #fff, 844px 828px #fff, 543px 35px #fff, 685px 13px #fff, 144px 672px #fff, 697px 835px #fff, 333px 481px #fff, 636px 408px #fff, 555px 41px #fff, 1309px 259px #fff, 1771px 829px #fff, 527px 193px #fff, 385px 40px #fff, 267px 297px #fff, 844px 768px #fff, 530px 18px #fff, 1179px 353px #fff, 570px 55px #fff, 1909px 778px #fff, 472px 108px #fff, 958px 96px #fff, 449px 918px #fff, 1551px 124px #fff, 1153px 272px #fff, 1910px 522px #fff, 1434px 626px #fff, 1875px 73px #fff, 967px 182px #fff, 256px 135px #fff, 1160px 156px #fff, 41px 687px #fff, 1812px 149px #fff, 215px 826px #fff, 1450px 742px #fff, 581px 608px #fff, 1068px 265px #fff, 1500px 725px #fff, 1775px 666px #fff, 234px 632px #fff, 1446px 22px #fff, 703px 700px #fff, 317px 320px #fff, 1055px 52px #fff, 895px 803px #fff, 41px 924px #fff, 1154px 255px #fff, 831px 804px #fff, 1616px 881px #fff, 393px 765px #fff, 474px 499px #fff, 711px 265px #fff, 1238px 368px #fff, 1870px 679px #fff, 363px 312px #fff, 301px 71px #fff, 130px 515px #fff, 264px 153px #fff, 19px 207px #fff, 1706px 275px #fff, 333px 942px #fff, 773px 710px #fff, 518px 880px #fff, 471px 714px #fff, 1832px 730px #fff, 975px 777px #fff, 1758px 348px #fff, 1699px 469px #fff, 1524px 874px #fff, 1449px 250px #fff, 324px 558px #fff, 1788px 908px #fff, 1753px 749px #fff, 1753px 696px #fff, 94px 772px #fff, 1440px 997px #fff, 1772px 153px #fff, 1321px 453px #fff, 950px 945px #fff, 727px 898px #fff, 1695px 46px #fff, 103px 677px #fff, 401px 359px #fff, 1291px 220px #fff, 1190px 667px #fff, 1387px 747px #fff, 796px 403px #fff, 740px 341px #fff, 1645px 116px #fff, 207px 481px #fff, 1021px 147px #fff, 1448px 713px #fff, 54px 922px #fff, 23px 399px #fff, 169px 65px #fff, 1281px 848px #fff, 1401px 833px #fff, 1600px 152px #fff, 823px 985px #fff, 769px 565px #fff, 176px 940px #fff, 1705px 822px #fff, 1570px 490px #fff, 872px 874px #fff, 11px 138px #fff, 1706px 510px #fff, 1786px 415px #fff, 222px 129px #fff, 1590px 378px #fff, 1354px 699px #fff, 895px 825px #fff, 30px 987px #fff, 1432px 905px #fff, 657px 875px #fff, 1688px 156px #fff, 1824px 635px #fff, 593px 858px #fff, 1280px 625px #fff, 448px 850px #fff, 974px 645px #fff, 1777px 243px #fff, 1520px 147px #fff, 447px 345px #fff, 72px 23px #fff, 1331px 810px #fff, 260px 24px #fff, 1332px 780px #fff, 478px 816px #fff, 727px 226px #fff, 396px 439px #fff, 818px 264px #fff, 125px 422px #fff, 319px 642px #fff, 655px 201px #fff, 1281px 775px #fff, 107px 789px #fff, 834px 511px #fff, 1033px 21px #fff, 1347px 734px #fff, 31px 740px #fff, 813px 756px #fff, 1187px 247px #fff, 1184px 91px #fff, 168px 862px #fff, 220px 702px #fff, 292px 515px #fff, 1652px 15px #fff, 1356px 701px #fff, 1883px 549px #fff, 266px 536px #fff, 123px 841px #fff, 963px 981px #fff, 574px 438px #fff, 410px 253px #fff, 1727px 356px #fff;
}
 .meteor-1 {
 position: absolute;
 top: 287px;
 left: 50%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 6.5s linear infinite;
}
 .meteor-1:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-2 {
 position: absolute;
 top: 298px;
 left: 39%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 9.4s linear infinite;
}
 .meteor-2:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-3 {
 position: absolute;
 top: 237px;
 left: 94%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 3.3s linear infinite;
}
 .meteor-3:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-4 {
 position: absolute;
 top: 76px;
 left: 47%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 7.4s linear infinite;
}
 .meteor-4:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-5 {
 position: absolute;
 top: 262px;
 left: 39%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 4.4s linear infinite;
}
 .meteor-5:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-6 {
 position: absolute;
 top: 245px;
 left: 68%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 7.6s linear infinite;
}
 .meteor-6:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-7 {
 position: absolute;
 top: 51px;
 left: 60%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 7.8s linear infinite;
}
 .meteor-7:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-8 {
 position: absolute;
 top: 133px;
 left: 22%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 5.6s linear infinite;
}
 .meteor-8:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-9 {
 position: absolute;
 top: 153px;
 left: 65%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 4.4s linear infinite;
}
 .meteor-9:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-10 {
 position: absolute;
 top: 298px;
 left: 48%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 6.5s linear infinite;
}
 .meteor-10:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-11 {
 position: absolute;
 top: 287px;
 left: 40%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 9.4s linear infinite;
}
 .meteor-11:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-12 {
 position: absolute;
 top: 79px;
 left: 13%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 3.2s linear infinite;
}
 .meteor-12:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-13 {
 position: absolute;
 top: 179px;
 left: 25%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 8.2s linear infinite;
}
 .meteor-13:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-14 {
 position: absolute;
 top: 167px;
 left: 20%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 9.2s linear infinite;
}
 .meteor-14:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 .meteor-15 {
 position: absolute;
 top: 103px;
 left: 93%;
 width: 300px;
 height: 1px;
 transform: rotate(-45deg);
 background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
 animation: meteor 7s linear infinite;
}
 .meteor-15:before {
 content: "";
 position: absolute;
 width: 4px;
 height: 5px;
 border-radius: 50%;
 margin-top: -2px;
 background: rgba(255, 255, 255, .7);
 box-shadow: 0 0 15px 3px #fff;
}
 @keyframes meteor {
 0% {
 opacity: 1;
 margin-top: -300px;
 margin-right: -300px;
}
 12% {
 opacity: 0;
}
 15% {
 margin-top: 300px;
 margin-left: -600px;
 opacity: 0;
}
 100% {
 opacity: 0;
}
}
` }, void 0), _jsxs(Box, { sx: { position: "relative", width: "100%", height: "800px", marginTop: "200px" }, children: [_jsx(Box, { className: "meteor-1" }, void 0), _jsx(Box, { className: "meteor-2" }, void 0), _jsx(Box, { className: "meteor-3" }, void 0), _jsx(Box, { className: "meteor-4" }, void 0), _jsx(Box, { className: "meteor-5" }, void 0), _jsx(Box, { className: "meteor-6" }, void 0), _jsx(Box, { className: "meteor-7" }, void 0), _jsx(Box, { className: "meteor-8" }, void 0), _jsx(Box, { className: "meteor-9" }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=MeteorShower.js.map